import React from "react";
// import { collection, addDoc } from "firebase/firestore/lite";
// import { db } from "./firebaseConfig";
// import axios from "axios";
import "aos/dist/aos.css";
import { MdOutlineAlternateEmail } from "react-icons/md";
import { FaWhatsapp } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa";
import { FaGithub } from "react-icons/fa";

const Contact = () => {
  // Form state variables - commented out as form is disabled
  // const [fullName, setFullName] = useState("");
  // const [email, setEmail] = useState("");
  // const [subject, setSubject] = useState("");
  // const [message, setMessage] = useState("");
  // const [success, setSuccess] = useState(false);
  // const [isEmailValid, setIsEmailValid] = useState(false);
  // const [captchaIsDone, setCaptchaIsDone] = useState(false);
  // const [showSubmitButton, setShowSubmitButton] = useState(false);
  // const [isLoading, setIsLoading] = useState(false);

  // const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/u;
  // const key = "6LfXXtMnAAAAAAwm1r3zNSHpqL9f1LflAfdDjirq444444444";

  // Form submission handler - commented out as form is disabled
  // const handleFormSubmit = async (e) => {
  //   e.preventDefault();

  //   if (!isEmailValid) {
  //     return;
  //   }

  //   setIsLoading(true);

  //   try {
  //     // Optional: Send to backend API if needed
  //     try {
  //       await axios.post('#', {
  //         fullName,
  //         email,
  //         subject,
  //         message,
  //       });
  //     } catch (apiError) {
  //       // API might not be configured, continue with Firebase
  //       console.log("API endpoint not available, saving to Firebase only");
  //     }

  //     // Save to Firebase
  //     await addDoc(collection(db, "messages"), {
  //       fullName,
  //       email,
  //       subject,
  //       message,
  //       timestamp: new Date().toISOString(),
  //     });

  //     // Reset form
  //     setFullName("");
  //     setEmail("");
  //     setSubject("");
  //     setMessage("");
  //     setIsEmailValid(false);

  //     setSuccess(true);

  //     setTimeout(() => {
  //       setSuccess(false);
  //     }, 5000);

  //   } catch (error) {
  //     console.error("Error adding document: ", error);
  //     alert("Failed to send message. Please try again or contact me directly via email.");
  //   }

  //   setIsLoading(false);
  // };

  // const handleEmailChange = (e) => {
  //   const value = e.target.value;
  //   setEmail(value);
  //   setIsEmailValid(emailRegex.test(value));
  // };

  return (
    <>
      <hr className="border-gray-300 dark:border-gray-600 border-1" />
 
          <section
   id="contact"
    className="bg-white dark:bg-gray-780 py-20 transition-colors duration-300"
  > 
        <div className="container mx-auto px-4">
          {/* Section Header */}
          <div className="text-center mb-12">
            <h1 className="text-3xl md:text-4xl font-bold text-gray-800 dark:text-white mb-4 transition-colors duration-300">
              <span className="border-b-4 border-primaryColor dark:border-primaryColorDark pb-2 transition-colors duration-300">
                GET IN TOUCH
              </span>
            </h1>
            <p className="text-gray-600 dark:text-gray-400 text-lg max-w-2xl mx-auto transition-colors duration-300">
              Have a project in mind or want to collaborate? Feel free to reach out!
            </p>
          </div>

          <div className="max-w-4xl mx-auto">
            {/* Contact Information */}
            <div className="space-y-6">
              <div className="text-center mb-8">
                <h2 className="text-2xl font-bold text-black dark:text-white mb-4">
                  Contact Information
                </h2>
                <p className="text-gray-600 dark:text-gray-400">
                  I'm always open to discussing new projects, creative ideas, or opportunities to be part of your visions.
                </p>
              </div>

              <div className="grid sm:grid-cols-2 gap-4">
                <a
                  href="mailto:leachouri2019@gmail.com"
                  className="flex items-center gap-4 p-4 bg-white dark:bg-gray-700 rounded-lg shadow-md hover:shadow-lg transition-all duration-300 hover:scale-105 group"
                >
                  <div className="bg-primaryColor/10 dark:bg-primaryColorDark/20 p-3 rounded-full group-hover:bg-primaryColor dark:group-hover:bg-primaryColorDark transition-colors">
                    <MdOutlineAlternateEmail className="text-2xl text-primaryColor dark:text-primaryColorDark group-hover:text-white transition-colors" />
                  </div>
                  <div>
                    <p className="text-sm text-gray-500 dark:text-gray-400">Email</p>
                    <p className="text-gray-800 dark:text-white font-semibold text-sm sm:text-base">leachouri2019@gmail.com</p>
                  </div>
                </a>

                <a
                  href="https://wa.me/212613891359"
                  target="_blank"
                  rel="noreferrer"
                  className="flex items-center gap-4 p-4 bg-white dark:bg-gray-700 rounded-lg shadow-md hover:shadow-lg transition-all duration-300 hover:scale-105 group"
                >
                  <div className="bg-green-100 dark:bg-green-900/30 p-3 rounded-full group-hover:bg-green-500 transition-colors">
                    <FaWhatsapp className="text-2xl text-green-600 dark:text-green-400 group-hover:text-white" />
                  </div>
                  <div>
                    <p className="text-sm text-gray-500 dark:text-gray-400">WhatsApp</p>
                    <p className="text-gray-800 dark:text-white font-semibold text-sm sm:text-base">+212 613891359</p>
                  </div>
                </a>

                <a
                  href="https://github.com/leachouri"
                  target="_blank"
                  rel="noreferrer"
                  className="flex items-center gap-4 p-4 bg-white dark:bg-gray-700 rounded-lg shadow-md hover:shadow-lg transition-all duration-300 hover:scale-105 group"
                >
                  <div className="bg-gray-100 dark:bg-gray-600 p-3 rounded-full group-hover:bg-gray-800 dark:group-hover:bg-gray-500 transition-colors">
                    <FaGithub className="text-2xl text-gray-800 dark:text-gray-300 group-hover:text-white" />
                  </div>
                  <div>
                    <p className="text-sm text-gray-500 dark:text-gray-400">GitHub</p>
                    <p className="text-gray-800 dark:text-white font-semibold text-sm sm:text-base">@leachouri</p>
                  </div>
                </a>

                <a
                  href="https://www.linkedin.com/in/leachouri"
                  target="_blank"
                  rel="noreferrer"
                  className="flex items-center gap-4 p-4 bg-white dark:bg-gray-700 rounded-lg shadow-md hover:shadow-lg transition-all duration-300 hover:scale-105 group"
                >
                  <div className="bg-blue-100 dark:bg-blue-900/30 p-3 rounded-full group-hover:bg-blue-600 transition-colors">
                    <FaLinkedin className="text-2xl text-blue-600 dark:text-blue-400 group-hover:text-white" />
                  </div>
                  <div>
                    <p className="text-sm text-gray-500 dark:text-gray-400">LinkedIn</p>
                    <p className="text-gray-800 dark:text-white font-semibold text-sm sm:text-base">LEACHOURI Mohamed</p>
                  </div>
                </a>
              </div>
            </div>

            {/* Contact Form - COMMENTED OUT: Form functionality disabled */}
            {/* 
            <div className="bg-white dark:bg-gray-700 p-8 rounded-xl shadow-xl">
              <h2 className="text-2xl font-bold text-black dark:text-white mb-6">
                Send a Message
              </h2>
              
              {success && (
                <div className="mb-6 p-4 bg-green-100 dark:bg-green-900/30 border border-green-400 dark:border-green-600 rounded-lg">
                  <p className="text-green-800 dark:text-green-300 font-semibold">
                    ✓ Message sent successfully! I'll get back to you soon.
                  </p>
                </div>
              )}

              <form onSubmit={handleFormSubmit} className="space-y-6">
                <div>
                  <label htmlFor="fullName" className="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">
                    Full Name *
                  </label>
                  <input
                    type="text"
                    id="fullName"
                    value={fullName}
                    onChange={(e) => setFullName(e.target.value)}
                    required
                    className="w-full px-4 py-3 border-2 border-gray-300 dark:border-gray-600 rounded-lg 
                             focus:border-primaryColor dark:focus:border-blue-400 focus:outline-none 
                             bg-white dark:bg-gray-600 text-black dark:text-white transition-colors"
                    placeholder="Your name"
                  />
                </div>

                <div>
                  <label htmlFor="email" className="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">
                    Email *
                  </label>
                  <input
                    type="email"
                    id="email"
                    value={email}
                    onChange={handleEmailChange}
                    required
                    className={`w-full px-4 py-3 border-2 rounded-lg focus:outline-none 
                             bg-white dark:bg-gray-700 text-black dark:text-white transition-colors
                             ${isEmailValid || email === '' 
                               ? 'border-gray-300 dark:border-gray-600 focus:border-primaryColor dark:focus:border-blue-400' 
                               : 'border-red-400 dark:border-red-600'}`}
                    placeholder="your.email@example.com"
                  />
                  {email && !isEmailValid && (
                    <p className="text-red-500 text-sm mt-1">Please enter a valid email address</p>
                  )}
                </div>

                <div>
                  <label htmlFor="subject" className="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">
                    Subject *
                  </label>
                  <input
                    type="text"
                    id="subject"
                    value={subject}
                    onChange={(e) => setSubject(e.target.value)}
                    required
                    className="w-full px-4 py-3 border-2 border-gray-300 dark:border-gray-600 rounded-lg 
                             focus:border-primaryColor dark:focus:border-blue-400 focus:outline-none 
                             bg-white dark:bg-gray-600 text-black dark:text-white transition-colors"
                    placeholder="What's this about?"
                  />
                </div>

                <div>
                  <label htmlFor="message" className="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">
                    Message *
                  </label>
                  <textarea
                    id="message"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    required
                    rows="5"
                    className="w-full px-4 py-3 border-2 border-gray-300 dark:border-gray-600 rounded-lg 
                             focus:border-primaryColor dark:focus:border-blue-400 focus:outline-none 
                             bg-white dark:bg-gray-700 text-black dark:text-white transition-colors resize-none"
                    placeholder="Tell me about your project or idea..."
                  />
                </div>

                <button
                  type="submit"
                  disabled={isLoading || !isEmailValid}
                  className={`w-full py-3 px-6 rounded-lg font-semibold text-white transition-all duration-300
                           ${isLoading || !isEmailValid
                             ? 'bg-gray-400 dark:bg-gray-600 cursor-not-allowed'
                             : 'bg-primaryColor dark:bg-primaryColorDark hover:bg-blue-600 dark:hover:bg-blue-500 hover:scale-105 hover:shadow-lg'}`}
                >
                  {isLoading ? (
                    <span className="flex items-center justify-center">
                      <span className="animate-spin mr-2">⏳</span>
                      Sending...
                    </span>
                  ) : (
                    'Send Message →'
                  )}
                </button>
              </form>
            </div>
            */}
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
